
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import QuizStart from "@/components/QuizStart";
import Quiz from "@/components/Quiz";
import ResultsSummary from "@/components/ResultsSummary";
import { quizQuestions } from "@/data/quizQuestions";
import { calculateQuizResult } from "@/utils/quizUtils";
import { QuizResult } from "@/types";

const AssessmentPage: React.FC = () => {
  const navigate = useNavigate();
  const [assessmentState, setAssessmentState] = useState<'start' | 'quiz' | 'results'>('start');
  const [answers, setAnswers] = useState<Record<string, string>>({});
  const [result, setResult] = useState<QuizResult | null>(null);

  const handleStartQuiz = () => {
    setAssessmentState('quiz');
  };

  const handleFinishQuiz = (quizAnswers: Record<string, string>) => {
    setAnswers(quizAnswers);
    const quizResult = calculateQuizResult(quizQuestions, quizAnswers);
    
    // Store result in sessionStorage for the results page
    sessionStorage.setItem('quizResult', JSON.stringify(quizResult));
    
    setResult(quizResult);
    setAssessmentState('results');
  };

  const handleRestartQuiz = () => {
    setAnswers({});
    setResult(null);
    setAssessmentState('start');
  };
  
  const handleViewDetailedReport = () => {
    navigate('/results');
  };

  return (
    <Layout>
      <div className="py-12">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            {assessmentState === 'start' && (
              <QuizStart onStart={handleStartQuiz} />
            )}
            {assessmentState === 'quiz' && (
              <Quiz 
                questions={quizQuestions} 
                onFinish={handleFinishQuiz} 
              />
            )}
            {assessmentState === 'results' && result && (
              <ResultsSummary 
                result={result}
                onRestart={handleRestartQuiz}
                onGetReport={handleViewDetailedReport}
              />
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AssessmentPage;
